import React from 'react';
import _ from 'lodash';
import { Form, Label } from 'semantic-ui-react';

const REQUIRED_FIELD_SYMBOL = "*";

function HtmlLabel(props) {
  const { label, required, id } = props;

  if (!label) {
    return null;
  }

  return (
    <label htmlFor={id}>
      {required ? label + REQUIRED_FIELD_SYMBOL : label}
    </label>
  );
}

function ErrorList(props) {
  const { errors } = props;

  if (_.isEmpty(errors)) {
    return null;
  }

  let errorList = _.map(errors, (error, i) => {
    return (
      <Label key={i} basic color="red" pointing>{error}</Label>
    );
  });

  return (
    <div>
      {errorList}
    </div>
  );
}

function Field(props) {
  const {
    id,
    label,
    children,
    errors,
    rawErrors,
    help,
    description,
    hidden,
    required,
    displayLabel
  } = props;

  if (hidden) {
    return children;
  }

  return (
    <Form.Field error={!_.isEmpty(rawErrors)}>
      {displayLabel && <HtmlLabel label={label} required={required} id={id} />}
      {displayLabel && description ? description : null}
      {children}
      {errors}
      <ErrorList errors={rawErrors} />
      {help}
    </Form.Field>
  );
}

export default function FieldTemplate(props) {
  const {
    children,
    schema
  } = props;

  if (schema && schema.type === 'object') {
    return children;
  }

  return Field(props);
}



// WEBPACK FOOTER //
// ./src/components/ui/semantic-form/field-template.js